import { z } from "zod";

export const schema = z.object({
  manages_gbp_review_replies: z.boolean()
});

export type Schema = z.infer<typeof schema>;
